<template>
  <section class="section">
    <b-form>
      <b-col>
        <b-card title="Regole BlackBox">
          <div class="d-flex align-item-center mt-4">
            <b-btn class="btn btn-secondary mr-2">
              <a
                class="download-model"
                href="/static/blackbox_rules_model.csv"
                download
                >Scarica modello</a
              >
            </b-btn>
            <b-btn
              class="btn btn-secondary mr-2"
              @click="$bvModal.show('modalUpload')"
              >Importa</b-btn
            >
            <b-btn class="btn btn-secondary mr-2" @click="exportData()"
              >Esporta</b-btn
            >
            <b-btn class="btn btn-secondary mr-2" @click="addNewRule()"
              >Nuova regola</b-btn
            >
            <input
              type="text"
              class="form-control width-500"
              placeholder="Cerca..."
              v-model="filter"
            />
          </div>
          <div
            class="d-flex align-items-center pointer mt-4"
            v-for="(rule, index) in rulesShowed"
            :key="index"
            @click="editRule(rule, index)"
          >
            <span class="mx-1">{{ index + 1 }}.</span>
            <span v-if="rule.label" class="condition mx-1">{{
              rule.label
            }}</span>
            <div v-if="rule.format">
              +<span class="condition mx-1">{{ rule.format }}</span>
            </div>
            <div v-if="rule.channel_code_from">
              +<span class="condition mx-1">{{ rule.channel_code_from }}</span>
            </div>
            <font-awesome-icon icon="arrow-right" class="mx-1" />
            <font-awesome-icon
              icon="ban"
              class="red mx-1"
              v-if="rule.action == 'DROP'"
            />
            <span v-if="rule.convert_to" class="transformation mx-1">{{
              convertToName(rule.convert_to)
            }}</span>
            <span v-if="rule.source_code" class="transformation mx-1">{{
              sourceCodeName(rule.source_code)
            }}</span>
            <span
              v-if="rule.multiplier"
              class="d-flex align-items-center transformation mx-1"
            >
              <font-awesome-icon icon="xmark" class="font-size-12 mr-1" />{{
                rule.multiplier
              }}
            </span>
            <span
                v-if="rule.addition"
                class="d-flex align-items-center transformation mx-1"
              >
                <font-awesome-icon icon="plus" class="font-size-12 mr-1" />{{
                  rule.addition
                }}
              </span>
          </div>
          <div v-if="rules.length > 10" class="d-flex justify-content-end mt-4">
            <b-btn class="btn btn-secondary" @click="addNewRule()"
              >Nuova regola</b-btn
            >
          </div>
        </b-card>
        <b-modal
          id="modalForm"
          ref="modal"
          size="xl"
          centered
          :title="titleModal()"
          header-bg-variant="warning"
        >
          <form v-if="isEditMode" role="form" ref="form" class="mt-4">
            <!--<span class="mx-1">{{ lastId }}.</span>-->
            <div class="rule-container p-3">
              <div class="d-flex justify-content-between">
                <h5>Condizioni</h5>
                <!--<span class="pointer" @click="isEditMode = false">
                                    <font-awesome-icon icon="rectangle-xmark" />
                                </span>-->
              </div>
              <div class="d-flex">
                <div class="mr-3">
                  <label class="form-label">Label</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.label"
                  />
                </div>
                <div class="width-200 mr-3">
                  <label class="form-label">Format</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.format"
                  />
                </div>
                <div class="width-200 mr-3">
                  <label class="form-label">Codice canale</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.channel_code_from"
                  />
                </div>
              </div>
              <h5 class="mt-3">Trasforma</h5>
              <div class="d-flex">
                <div class="width-300 mr-3">
                  <label class="form-label">Azione</label>
                  <v-select
                    class="background-white"
                    :clearable="false"
                    v-model="form.action"
                    :options="actionsList"
                    :reduce="(item) => item.value"
                    label="label"
                    value="value"
                  />
                </div>
                <div class="width-400 mr-3">
                  <label class="form-label">Misura</label>
                  <v-select
                    class="background-white"
                    :disabled="form.action == 'DROP'"
                    :clearable="true"
                    v-model="form.convert_to"
                    :reduce="(item) => item.code"
                    :options="measuresTypeList"
                    label="name"
                    value="code"
                    :filter-by="measuresFilter"
                  />
                </div>
                <div class="width-300 mr-3">
                  <label class="form-label">Canale o parametro</label>
                  <v-select
                    class="background-white"
                    :disabled="form.action == 'DROP'"
                    :clearable="true"
                    v-model="form.source_code"
                    :reduce="(item) => item.value"
                    :options="sourceCodesList"
                    label="label"
                    value="value"
                    :filter-by="channelsFilter"
                    :selectable="(option) => !option.group"
                  />
                </div>                
              </div>
              <b-row class="mt-3">
                <b-col>
                    <label class="form-label">Moltiplicatore</label>
                    <input
                      type="text"
                      class="form-control"
                      :disabled="form.action == 'DROP'"
                      v-model="form.multiplier"
                    />
                    </b-col>
                    <b-col>
                      <label class="form-label">Incremento (post moltiplicatore)</label>
                      <input
                        type="text"
                        class="form-control"
                        :disabled="form.action == 'DROP'"
                        v-model="form.addition"
                      />
                </b-col>
                <b-col></b-col>
              </b-row>
            </div>
          </form>
          <template #modal-footer>
            <div class="d-flex align-items-end">
              <button
                v-if="form.id"
                type="button"
                class="btn btn-danger"
                v-b-modal.modalDelete
              >
                Elimina
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit()"
              >
                Salva
              </button>
            </div>
          </template>
        </b-modal>
        <b-modal
          id="modalDelete"
          ref="modal"
          centered
          title="Conferma cancellazione"
          header-bg-variant="danger"
          @ok="deleteRule()"
        >
          <p>
            Procedere con la cancellazione della regola BlackBox
            <b>{{ this.form.label }}</b
            >?
          </p>
        </b-modal>
        <b-modal
          id="modalUpload"
          ref="modalUpload"
          title="Importazione dati"
          size="md"
          centered
          @ok="loadRules()"
          @cancel="$bvModal.hide('modalUpload')"
        >
          <div class="p-4">
            <label class="form-label">Tipo operazione: </label>
            <v-select
              class="background-white"
              :clearable="false"
              v-model="operationType"
              :options="operationTypesList"
              :reduce="(item) => item.value"
              label="label"
              value="value"
            />
            <div class="d-flex align-items-center my-3">
              <label class="form-label mr-2">Upload: </label>

              <file-upload
                ref="uploadEl"
                v-model="files"
                extensions="csv"
                :post-action="`/api/v1/blackbox/upload/${operationType}`"
                error=""
                :headers="headers"
                :multiple="false"
                :size="0"
              >
                <b-btn variant="primary">
                  <font-awesome-icon icon="cloud-upload-alt" />
                  Seleziona
                </b-btn>
              </file-upload>

              <b-btn
                type="secondary"
                class="ml-2"
                v-if="
                  files.length && (!$refs.uploadEl || !$refs.uploadEl.active)
                "
                @click.prevent="$refs.uploadEl.active = true"
              >
                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                Carica
              </b-btn>
            </div>
            <span class="form-label"
              >Caricare il CSV secondo il modello fornito, non modificare
              l'ordine dei campi. La prima riga deve contenere i nomi dei
              campi.</span
            >

            <div class="mt-3">
              <span
                v-if="
                  files[0] && files[0].response && files[0].response.code == -2
                "
                class="form-label"
                style="color: red"
                >Importazione fallita: file CSV non valido</span
              >
              <span
                v-if="
                  files[0] && files[0].response && files[0].response.code != -2
                "
                class="form-label"
                style="color: red"
                >{{ files[0].response.error }}</span
              >
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-form>
  </section>
</template>

<script>
import vSelect from "vue-select";
import FileUpload from "vue-upload-component";

var VueCookie = require("vue-cookie");

export default {
  name: "BlackBoxRules",
  components: {
    vSelect,
    FileUpload,
  },
  data() {
    return {
      actionsList: [
        { label: "Processa", value: "PROCESS" },
        { label: "Scarta", value: "DROP" },
      ],
      measuresTypeList: [],
      form: {
        label: "",
        channel_code_from: null,
        format: null,
        action: "PROCESS",
        convert_to: null,
        source_code: null,
        multiplier: null,
        addition: null,
      },
      channels: [],
      parameters: [],
      sourceCodesList: [],
      filter: null,
      rules: [],
      rulesShowed: [],
      isEditMode: false,
      lastId: null,
      operationType: "add",
      operationTypesList: [
        { label: "Aggiungi", value: "add" },
        { label: "Sostituisci", value: "sub" },
      ],
      files: [],
      loaded: 0,
      responses: [],
      interval: null,
      importedRules: [],
    };
  },
  async created() {
    await this.loadMeasureTypes();
    this.loadSourceCodes();
    await this.loadRules();
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.user && this.$store.state.user.level == 1;
    },
    headers() {
      return {
        Authorization: VueCookie.get("token"),
      };
    },
  },

  methods: {
    exportData() {
      let arrayRules = [];
      arrayRules.push([
        "label",
        "channel_code_from",
        "format",
        "convert_to",
        "source_code",
        "multiplier",
        "addition",
        "action",
      ]);
      this.rulesShowed.forEach((item) => {
        arrayRules.push([
          item.label,
          item.channel_code_from,
          item.format,
          item.convert_to,
          item.source_code,
          item.multiplier,
          item.addition,
          item.action,
        ]);
      });

      arrayRules.forEach((row) => {
        row.join(",");
      });

      var downloadLink = document.createElement("a");
      downloadLink.href =
        "data:text/csv;charset=utf-8," + encodeURI(arrayRules.join("\n"));
      downloadLink.download = "export-blackbox-rules.csv";
      document.body.appendChild(downloadLink);
      downloadLink.innerHTML = "DOWNLOAD";
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    titleModal() {
      if (this.form.id) {
        return `Modifica regola ${this.lastId}`;
      }
      return "Nuova regola";
    },
    sourceCodeName(value) {
      const result = this.sourceCodesList.find((item) => item.value == value);
      if (result) {
        return result.label;
      }
      return value;
    },
    convertToName(code) {
      const result = this.measuresTypeList.find((item) => item.code == code);
      if (result) {
        return result.name;
      }
      return code;
    },
    async deleteRule() {
      try {
        this.$store.commit("loading");
        await this.$store
          .dispatch("blackbox/delete", this.form.id)
          .then((response) => {
            if (response.code != 1) {
              this.$notify({
                type: "error",
                text: response.message,
                title: "Errore",
              });
            } else {
              this.$notify({
                type: "success",
                text: "Regola BlackBox rimossa correttamente",
                title: "Successo",
              });
            }
            this.$store.commit("stopLoading");
          });
        this.$nextTick(() => {
          this.$bvModal.hide("modalForm");
        });
        this.isEditMode = false;
        await this.loadRules();
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
    editRule(rule, index) {
      this.isEditMode = true;
      this.$nextTick(() => {
        this.$bvModal.show("modalForm");
      });
      this.lastId = index + 1;
      this.form = { ...rule };
    },
    loadSourceCodes() {
      this.$store.state.user.sites.forEach((site) => {
        if (site.channels) {
          this.sourceCodesList.push({
            label: "Canali",
            value: null,
            group: true,
          });
          site.channels.forEach((item) => {
            this.sourceCodesList.push({ label: item.name, value: item.code });
          });
        }
        if (site.parameters) {
          this.sourceCodesList.push({
            label: "Parametri",
            value: null,
            group: true,
          });
          site.parameters.forEach((item) => {
            this.sourceCodesList.push({ label: item.name, value: item.code });
          });
        }
      });
    },
    async loadMeasureTypes() {
      try {
        this.$store.commit("loading");
        await this.$store
          .dispatch("sites/measureTypesList")
          .then((response) => {
            this.measuresTypeList = response;
            this.$store.commit("stopLoading");
          });
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
    addNewRule() {
      this.form = {
        action: "PROCESS",
      };
      this.isEditMode = true;
      this.$nextTick(() => {
        this.$bvModal.show("modalForm");
      });
      this.lastId = this.rules.length + 1;
    },
    async handleSubmit() {
      if (
        !this.form.label &&
        !this.form.channel_code_from &&
        !this.form.format
      ) {
        this.$notify({
          type: "error",
          text: "Inserire almeno una condizione",
          title: "Errore",
        });
        return;
      }
      function checkEqual(a, b) {
        if (!a) {
          a = "";
        }
        if (!b) {
          b = "";
        }
        if (a == b) {
          return true;
        }
        return false;
      }

      const control = this.rules.find(
        (item) =>
          item.id != this.form.id &&
          checkEqual(item.label, this.form.label) &&
          checkEqual(item.format, this.form.format) &&
          checkEqual(item.channel_code_from, this.form.channel_code_from)
      );

      if (control) {
        this.$notify({
          type: "error",
          text: "Attenzione, regola duplicata",
          title: "Errore",
        });
      } else {
        await this.submit();
      }
    },
    async submit() {
      let newForm = this.form;
      if (newForm.action == "DROP") {
        newForm.convert_to = null;
        newForm.source_code = null;
        newForm.multiplier = null;
        newForm.addition = null;
      }
      try {
        this.$store.commit("loading");
        if (!this.form.id) {
          await this.$store
            .dispatch("blackbox/store", newForm)
            .then((response) => {
              if (response.code != 1) {
                this.$notify({
                  type: "error",
                  text: response.message,
                  title: "Errore",
                });
              } else {
                this.$notify({
                  type: "success",
                  text: "Regola BlackBox salvata correttamente",
                  title: "Successo",
                });
              }
            });
        } else {
          await this.$store
            .dispatch("blackbox/update", newForm)
            .then((response) => {
              if (response.code != 1) {
                this.$notify({
                  type: "error",
                  text: response.message,
                  title: "Errore",
                });
              } else {
                this.$notify({
                  type: "success",
                  text: "Regola BlackBox modificata correttamente",
                  title: "Successo",
                });
              }
            });
        }
        this.isEditMode = false;

        this.$nextTick(() => {
          this.$bvModal.hide("modalForm");
        });

        this.$store.commit("stopLoading");

        await this.loadRules();
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
    measuresFilter(option, label, search) {
      if (search) {
        let temp = search.toLowerCase();
        let name = option.name || "";
        let code = option.code || "";

        return (
          name.toLowerCase().indexOf(temp) > -1 ||
          code.toLowerCase().indexOf(temp) > -1
        );
      }
    },
    channelsFilter(option, label, search) {
      if (search) {
        let temp = search.toLowerCase();
        let label = option.label || "";
        let value = option.value || "";

        return (
          label.toLowerCase().indexOf(temp) > -1 ||
          value.toLowerCase().indexOf(temp) > -1 ||
          option.group
        );
      }
    },
    async loadRules() {
      this.form = {};
      try {
        this.$store.commit("loading");
        await this.$store.dispatch("blackbox/list").then((response) => {
          if (response.code != 1) {
            this.$notify({
              type: "error",
              text: response.message,
              title: "Errore",
            });
          } else {
            this.$notify({
              type: "success",
              text: "Regole BlackBox caricate correttamente",
              title: "Successo",
            });
            this.rules = response.data;
            this.rulesShowed = response.data;
          }
          this.$store.commit("stopLoading");
        });
      } catch (e) {
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
  },

  watch: {
    filter() {
      if (this.filter) {
        const filter = this.filter.toLowerCase();
        this.rulesShowed = this.rules.filter((rule) => {
          if (rule.label && rule.label.toLowerCase().indexOf(filter) > -1) {
            return true;
          }
          if (rule.format && rule.format.toLowerCase().indexOf(filter) > -1) {
            return true;
          }
          if (
            rule.channel_code_from &&
            rule.channel_code_from.toLowerCase().indexOf(filter) > -1
          ) {
            return true;
          }
          if (
            rule.convert_to &&
            rule.convert_to.toLowerCase().indexOf(filter) > -1
          ) {
            return true;
          }
          if (
            rule.convert_to &&
            this.convertToName(rule.convert_to).toLowerCase().indexOf(filter) >
              -1
          ) {
            return true;
          }
          if (
            rule.source_code &&
            rule.source_code.toLowerCase().indexOf(filter) > -1
          ) {
            return true;
          }
          if (
            rule.source_code &&
            this.sourceCodeName(rule.source_code)
              .toLowerCase()
              .indexOf(filter) > -1
          ) {
            return true;
          }
        });
      } else {
        this.rulesShowed = this.rules;
      }
    },
  },
};
</script>

<style scoped>
.download-model {
  text-decoration: none;
  color: #fff;
}
.download-model:hover {
  text-decoration: none;
  color: #fff;
}
.condition {
  border-radius: 5px;
  background: #cbe8ba;
  padding: 3px 8px;
}
.transformation {
  border-radius: 5px;
  background: #91e4fb;
  padding: 3px 8px;
}
.red {
  color: red;
}
.pointer {
  cursor: pointer;
}
.background-white {
  background: #fff;
}
.vs--searchable .vs__dropdown-toggle {
  background-color: #fff;
}
.width-100 {
  width: 100px;
}
.width-150 {
  width: 150px;
}
.width-200 {
  width: 200px;
}
.width-300 {
  width: 300px;
}
.width-400 {
  width: 400px;
}
.width-500 {
  width: 500px;
}
.font-size-12 {
  font-size: 12px;
}
.rule-container {
  background: #f0f0f0;
  border: 1px solid #f9f9f9;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/BlackBox/BlackBoxRules.vue